const Logo = () => {
  return (
    <div className="text-4xl animate-bounce cursor-pointer select-none">
      🍊
    </div>
  )
}

export default Logo 